// Bancos de dados do IndexedDB.
export const DB_MENUDINO_NAME = 'MenuDinoDB'
export const DB_CACHE_NAME = 'CacheDB'

// Tabelas do IndexedDB.
export const MERCHANT_STORE_NAME = 'merchant'
export const CATEGORIES_STORE_NAME = 'categories'
export const ITEMS_STORE_NAME = 'items'
export const PROMOTIONS_STORE_NAME = 'promotions'
export const PROMOTION_ITEMS_STORE_NAME = 'promotionItems'
export const STATUS_STORE_NAME = 'status'
export const DETAILED_ITEMS = 'detailedItems'

/** Tempo de expiração para dados salvos no IndexedDb. */
export const CACHE_EXPIRATION_MS = 1000 * 60 * 5

/** Tempo padrão para expiração do merchantSummary e merchantDetailed. */
export const MERCHANT_DATA_EXPIRATION_MINUTES = 10